export const eventTypeLabel = (value?: string | null): string => {
  const type = String(value || '').trim().toLowerCase().replace(/[\s.-]+/g, '_');
  if (/door_(unlocked|unlock_succeeded)|unlock_(succeeded|completed)|access_granted/.test(type)) return 'Door Unlocked';
  if (/door_locked|lock_succeeded/.test(type)) return 'Door Locked';
  if (/denied|failed|rejected/.test(type)) return 'Access Denied';
  if (/face.*(match|verified)/.test(type)) return 'Identity Verified';
  if (/credential.*created|pin.*created|code.*issued/.test(type)) return 'Access Code Created';
  if (/credential.*revoked|pin.*revoked|code.*revoked/.test(type)) return 'Access Code Revoked';
  return type
    ? type.split('_').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ')
    : 'Activity';
};

export const activityDescription = (event: Record<string, any>): string => {
  const actor = event.actor_name || event.person_name || event.caller_name || event.user_name;
  const unit = event.unit_number ? `Unit ${event.unit_number}` : '';
  const device = event.device_name || event.intercom_name;
  const property = event.property_name;
  const details = [actor, unit, device, property]
    .map(value => String(value || '').trim())
    .filter((value, index, values) => value && values.indexOf(value) === index);
  return details.join(' · ') || event.description || event.status || 'Recorded event';
};
